import { render, staticRenderFns } from "./delivery-zone-list.vue?vue&type=template&id=defbb880&"
import script from "./delivery-zone-list.vue?vue&type=script&lang=js&"
export * from "./delivery-zone-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports